/**
 * Card brand → icon for the Payment Info card (CWS-1508). Previously every card showed the
 * Mastercard logo whatever the brand.
 *
 * Accepts Stripe's `card.brand` / `card_present.brand` values (`visa`, `mastercard`, `amex`,
 * `discover`, …) as well as display spellings (`MasterCard`, `American Express`). Anything
 * else — a brand without its own icon, or no brand — gets the generic card icon.
 */

export const GENERIC_CARD_BRAND_ICON = 'assets/images/card-brands/card.svg';

const CARD_BRAND_ICONS: Record<string, string> = {
  visa: 'assets/images/card-brands/visa.svg',
  mastercard: 'assets/images/master_card.png',
  amex: 'assets/images/card-brands/amex.svg',
  americanexpress: 'assets/images/card-brands/amex.svg',
  discover: 'assets/images/card-brands/discover.svg',
};

const CARD_BRAND_NAMES: Record<string, string> = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  amex: 'American Express',
  americanexpress: 'American Express',
  discover: 'Discover',
  diners: 'Diners Club',
  jcb: 'JCB',
  unionpay: 'UnionPay',
  interac: 'Interac',
  eftposau: 'EFTPOS Australia',
  cartesbancaires: 'Cartes Bancaires',
};

function brandKey(brand: unknown): string {
  return String(brand ?? '')
    .toLowerCase()
    .replace(/[^a-z]/g, '');
}

/** Icon path for a card brand; the generic card icon when the brand has none. */
export function cardBrandIcon(brand: unknown): string {
  return CARD_BRAND_ICONS[brandKey(brand)] ?? GENERIC_CARD_BRAND_ICON;
}

/** Readable brand name for the icon's alt text; `Card` when unknown. */
export function cardBrandName(brand: unknown): string {
  return CARD_BRAND_NAMES[brandKey(brand)] ?? 'Card';
}
